// src/screens/ProfileSettings.jsx
import React, { useState, useEffect } from "react";
import "../css/ProfileSettings.css";
import { useNavigate } from "react-router-dom";
import { FiDownload } from "react-icons/fi";
import petsBannerImg from "../assets/pets_banner.png";

import Sidebar from "./Sidebar";
import Header from "./Header";
import PageTitle from "./PageTitleCompoent";
import api from "../api"; // ✅ centralized axios instance

export default function ProfileSettings() {
  const navigate = useNavigate();
  const handleBack = () => navigate(-1);

  const [profile, setProfile] = useState({
    first_name: "",
    last_name: "",
    date_of_birth: "",
    phone: "",
    city: "",
    country: "",
  });

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  // ✅ Fetch profile data on load
  useEffect(() => {
    const fetchProfile = async () => {
      try {
        setLoading(true);
        const res = await api.get("/admin-profile/"); // ✅ Correct endpoint
        let data = res.data;

        if (data.date_of_birth) {
          const parts = data.date_of_birth.split("-");
          if (parts.length === 3) {
            // Convert from DD-MM-YYYY to YYYY-MM-DD for input display
            const formattedDate = `${parts[2]}-${parts[1]}-${parts[0]}`;
            data.date_of_birth = formattedDate;
          }
        }

        setProfile(data);
      } catch (err) {
        console.error("Failed to fetch profile:", err.response || err.message || err);
        setError("Failed to load profile. Please try again.");
      } finally {
        setLoading(false);
      }
    };

    fetchProfile();
  }, []);

  // ✅ Handle input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setProfile((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // ✅ Handle update submit
  const handleUpdate = async (e) => {
    e.preventDefault();
    try {
      let dob = profile.date_of_birth;
      if (dob) {
        const parts = dob.split("-");
        if (parts.length === 3) {
          dob = `${parts[2]}-${parts[1]}-${parts[0]}`; // Convert to DD-MM-YYYY
        }
      }

      const formData = new FormData();
      formData.append("first_name", profile.first_name);
      formData.append("last_name", profile.last_name);
      formData.append("date_of_birth", dob);
      formData.append("phone", profile.phone);
      formData.append("city", profile.city);
      formData.append("country", profile.country);

      const res = await api.patch("/admin-profile/", formData);
      console.log("Update success:", res.data);
      alert("Profile updated successfully!");
    } catch (err) {
      console.error("Failed to update profile:", err.response || err.message || err);
      if (err.response) {
        alert("Update failed: " + JSON.stringify(err.response.data));
      } else {
        alert("Update failed: " + err.message);
      }
    }
  };

  return (
    <div className="container">
      <Sidebar />
      <div className="main">
        <Header />
        <div className="profile-settings">
          <PageTitle title="Profile Settings" onBack={handleBack} />

          <div className="banner">
            <img src={petsBannerImg} alt="Pets" />
          </div>

          {loading ? (
            <p>Loading profile...</p>
          ) : error ? (
            <p className="error">{error}</p>
          ) : (
            <form className="form-container" onSubmit={handleUpdate}>
              <div className="form-group">
                <label className="ps_label_name">First Name</label>
                <input
                  className="ps_form_input"
                  type="text"
                  name="first_name"
                  value={profile.first_name || ""}
                  onChange={handleChange}
                  placeholder="Enter first name"
                />
              </div>

              <div className="form-group">
                <label className="ps_label_name">Last Name</label>
                <input
                  className="ps_form_input"
                  type="text"
                  name="last_name"
                  value={profile.last_name || ""}
                  onChange={handleChange}
                  placeholder="Enter last name"
                />
              </div>

              <div className="form-group">
                <label className="ps_label_name">Date of Birth</label>
                <input
                  className="ps_form_input"
                  type="date"
                  name="date_of_birth"
                  value={profile.date_of_birth || ""}
                  onChange={handleChange}
                />
              </div>

              <div className="form-group">
                <label className="ps_label_name">Phone</label>
                <input
                  className="ps_form_input"
                  type="tel"
                  name="phone"
                  value={profile.phone || ""}
                  onChange={handleChange}
                  placeholder="Enter phone number"
                  pattern="[0-9]*"
                  inputMode="numeric"
                  onInput={(e) => {
                    e.target.value = e.target.value.replace(/[^0-9]/g, "");
                  }}
                />
              </div>

              <div className="form-group">
                <label className="ps_label_name">City</label>
                <select
                  className="ps_form_select"
                  name="city"
                  value={profile.city || ""}
                  onChange={handleChange}
                >
                  <option value="">Select City</option>
                  <option>Bengaluru</option>
                  <option>Chennai</option>
                  <option>Mumbai</option>
                </select>
              </div>

              <div className="form-group">
                <label className="ps_label_name">Country</label>
                <select
                  className="ps_form_select"
                  name="country"
                  value={profile.country || ""}
                  onChange={handleChange}
                >
                  <option value="">Select Country</option>
                  <option>India</option>
                  <option>USA</option>
                  <option>UK</option>
                </select>
              </div>

              <div className="form-group full-width">
                <button className="update-btn" type="submit">
                  <FiDownload className="download-icon" /> Update
                </button>
              </div>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
